import ApiClient from "shared/service/api/ApiClient";
import {
    Client,
    IRankingV3Element_Public,
    IRankingV3Report_Public,
    IRankingV3ReportEntity_Public,
    IRankingV3ReportFilter_Public,
    RankingV3Element_Public,
    RankingV3Element_PublicTenant,
    RankingV3Report_Public,
    RankingV3ReportEntity_Public,
    RankingV3ReportEntity_PublicLevel,
    RankingV3ReportEntity_PublicRankingType,
    RankingV3ReportFilter_Public,
    RankingV3ReportFilter_PublicLevel,
    RankingV3ReportFilter_PublicPeriod,
} from "shared/service/api/generated";
import { RankingReport } from "./api/models";
import _ from "lodash";

class RankingsService {
    private apiClient: Client;

    constructor(apiClient: Client) {
        this.apiClient = apiClient;
    }

    async getRankingReport(period: RankingV3ReportFilter_PublicPeriod): Promise<RankingReport> {
        const body = new RankingV3ReportFilter_Public({
            period: period,
        });

        const apiREsult = await this.apiClient.ranking_v3_report(body, undefined);
        return new RankingReport(apiREsult);
    }
}

export default new RankingsService(ApiClient);
